import React from 'react';
import { getActiveGame, getGameDisplayName, getGameCustomizeMeta } from '../../utils/gameHelpers';
import './adminGameBar.css';

export default function AdminGameContentHeader({ themeData, section }) {
  const activeGame = getActiveGame(themeData);
  const displayName = getGameDisplayName(activeGame);
  const meta = getGameCustomizeMeta(activeGame);
  const subtitle = section === 'rules'
    ? `Rules, labels, and settings for ${displayName}.`
    : meta.pageSubtitle;

  return (
    <div className="admin-game-content-header">
      <span className="admin-game-content-badge">Active game</span>
      <h2>
        {displayName}
        {section === 'rules' ? ' — Rules & Settings' : ` — ${meta.pageTitle}`}
      </h2>
      <p>{subtitle}</p>
    </div>
  );
}
